// extracted by mini-css-extract-plugin
export var content = "label-module--content--9d38f";
export var wrapper = "label-module--wrapper--b2550";